import HTTP from "../plugins/backendAPI";
import store from "../store";

export async function logout() {
  console.log("User is being logged out...");
  
  try {
    // 1. First, call server-side logout if SAML
    if (store.getters.userSSOAuthMethod === "SAML") {
      await HTTP.get("/auth/sign-out/saml").catch(() => {
        console.warn("SAML logout call failed, continuing with client-side cleanup");
      });
    }

    // 2. Clear HTTP authorization header
    HTTP.defaults.headers.common["Authorization"] = null;

    // 3. Comprehensive MSAL cleanup
    try {
      const msalInstance = store.getters.msalInstance;
      if (msalInstance) {
        // Get all accounts and log them out individually
        const accounts = msalInstance.getAllAccounts();
        accounts.forEach(account => {
          msalInstance.logoutPopup({ account }).catch(() => {});
        });
        
        // Clear MSAL caches
        await msalInstance.clearCache();
        msalInstance.setActiveAccount(null);
      }
    } catch (msalError) {
      console.warn("MSAL cleanup error:", msalError);
    }

    // 4. Clear store state
    await store.dispatch("deleteAuthorization");
    await store.dispatch("clearOrganizationitems");
    await store.dispatch("clearWorkspaceitems");
    await store.dispatch("saveWorkspaceId", -1);
    await store.dispatch("saveOrganizationId", -1);
    await store.dispatch("saveUserSSOAuthMethod", null);

    // 5. Clear all storage
    localStorage.clear();
    sessionStorage.clear();

    console.log("Client-side cleanup completed, redirecting to login...");

    // 6. Use hard redirect instead of router.push() to break SPA context
    const timestamp = Date.now();
    const redirectUrl = `/sign-in?logout=${timestamp}&nocache=${timestamp}`;
    
    // Force hard redirect - this is crucial!
    window.location.href = redirectUrl;
    
    // Fallback: if still in same page after 1 second, force reload
    setTimeout(() => {
      window.location.href = `/sign-in?force=${Date.now()}`;
    }, 1000);

  } catch (error) {
    console.error("Logout process error:", error);
    
    // Emergency cleanup and redirect
    localStorage.clear();
    sessionStorage.clear();
    window.location.href = `/sign-in?error=${Date.now()}`;
  }
}
